import {list, Loader, modal} from "@mc/mc-legacy";
import QSignDataApi from "../api/gen/qsign/QSignDataApi";
import PreRequestVO from "../api/gen/qsign/types/PreRequestVO";
import SignRequestInternalApi from "../api/gen/qsign/SignRequestInternalApi";
import PreNovyPozadavekForm from "../components/forms/PreNovyPozadavekForm";
import TypeSign from "../api/gen/qsign/types/TypeSign";
import React from "react";
import PreNovyPozadavekLegacyForm from "../components/forms/PreNovyPozadavekLegacyForm";

export const PRE_POZADAVEK_NEVYRIZENE_LIST = "prePozadavekNevyrizeneList";

const getPreRequestsByIds = (ids) => {
    return QSignDataApi.findPreRequestsByIds(ids);
};

const getPrePozadavkyAllIds = (parent, filter) => {
    return QSignDataApi.findNevyrizenePrePozadavkyPredkladatel();
};

export function fetchIfNeeded(forceFetch) {
    return (dispatch) => {
        dispatch(
            list.InfiniteListActions.fetchIfNeeded(
                PRE_POZADAVEK_NEVYRIZENE_LIST,
                null,
                getPrePozadavkyAllIds,
                getPreRequestsByIds,
                forceFetch
            )
        );
    };
}

export function loadMore() {
    return (dispatch, getState) => {
        dispatch(list.InfiniteListActions.loadMore(PRE_POZADAVEK_NEVYRIZENE_LIST, getPreRequestsByIds));
    };
}

export function invalidate() {
    return (dispatch) => {
        dispatch(list.InfiniteListActions.invalidate(PRE_POZADAVEK_NEVYRIZENE_LIST));
    };
}

export async function createRequestByPre(preRequest: PreRequestVO, history, onCloseAction) {

    const requestConfig = await SignRequestInternalApi.getRequestConfig().then((res) => {
        return res
    });

    const newForm = 'new' === requestConfig.batchForm.toLowerCase();

    let initialValues;
    let form;
    if (newForm) {
        form = PreNovyPozadavekForm;
        initialValues = {
            name: preRequest.name,
            description: preRequest.description,
            files: preRequest.requesDokuments
        };
    } else {
        form = PreNovyPozadavekLegacyForm;
        initialValues = {
            name: preRequest.name,
            description: preRequest.description,
            files: preRequest.requesDokuments,
            typeSign: TypeSign.CUSTOM
        }
    }

    return (dispatch) => {
        dispatch(
            modal.ModalActions.showAsyncWaiting(
                "Načítání detailu pre šablony",
                <Loader/>,
                SignRequestInternalApi.getUserCombinations(),
                (typeCombinationItems) => {
                    dispatch(modal.ModalActions.show(
                        form,
                        {
                            onSubmit: (data) => {
                                const {files, signers, _filesHack, ...other} = data;
                                return SignRequestInternalApi.createRequestByPreRequest(preRequest.id, {
                                    signers, ...other
                                });
                            },
                            onSubmitSuccess: () => {
                                dispatch(modal.ModalActions.hide());
                                history.push("/pre/pozadavky/nevyrizene");
                                onCloseAction && onCloseAction();
                            },
                            onClose: () => {
                                onCloseAction && onCloseAction();
                            },
                            initialValues: initialValues,
                            typeCombinationItems: typeCombinationItems,
                        },
                        "Nový požadavek na podpis dokumentů",
                        {
                            size: "full",
                            toggle: () => {
                            }
                        },
                    ))
                })
        );
    };
}
